import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { TenantExecutionStatus } from 'src/app/common/enums/statuses';
import { LinkRendererComponent } from 'src/app/shared/cell-renderers/link-renderer/link-renderer.component';

import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { CreateTenantModalComponent } from '../modals/create-tenant-modal/create-tenant-modal.component';
import { StatusRendererComponent } from '../status/status-renderer.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public gridColumnApi;
  public overlayLoadingTemplate;
  private gridApi;
  gridOptions: GridOptions;

  modalOption: NgbModalOptions = {};
  
  tenants: any = [];

  constructor(public tenantService: TenantService, private modalService: NgbModal, private route: ActivatedRoute, private router: Router) { 
    this.gridOptions = <GridOptions>{      
      columnDefs: [
        {
          headerName: 'Tenant', 
          field: 'tenantName', 
          minWidth: 100, 
          tooltipField: 'tenantName',
          sort: 'asc',
          sortable: true,
          sortingOrder: ["asc", "desc"],
          cellRendererFramework: LinkRendererComponent,
          cellRendererParams: function(params) {
            if(params.data.tenantStatusId == TenantExecutionStatus.Executing){
              params.value = params.data.tenantName;
            }
            else{
            params.linkEnabled = true;
            params.inRouterLink = `/details/${params.data.tenantName}`;
            params.value = params.data.tenantName;
            }
            return params;
          }
        },
        { headerName: 'Last Run Date', field: 'lastRunDateString', minWidth: 100, sortable: true, comparator: this.dateComparator,
          cellRenderer: function (params) {
            return params.data.lastRunDateString == null ? '' : moment(params.data.lastRunDateString).format('dddd, MMMM D, YYYY, h:mmA')
          }
        },
        { headerName: 'Last Run Outcome', field: 'lastRunOutcomeStatus',  cellRendererFramework: StatusRendererComponent, minWidth: 100, 
          sortable: true,
          sortingOrder: ["asc", "desc"]
        },           
        { headerName: 'Current Execution Step', field: 'current_Execution_Step', minWidth: 100, sortable: false }
      ],
      defaultColDef: {       
        cellClass: 'table-cell',
        lockPosition: true
      },
      enableBrowserTooltips: true,
      rowHeight: 40,
      headerHeight: 40,
      suppressCellSelection: true      
    };
  }

  ngOnInit(){
    this.listTenants();
  }

  listTenants(overrideGridOverlay?: boolean) {
    const self = this;

    self.tenantService.listTenants().subscribe((tenants: {}) => {      
      self.tenants = tenants;
      self.gridOptions.api.setRowData(this.tenants);

      if(overrideGridOverlay) {
        this.gridApi.hideOverlay();
      }
    });
  }

  refresh(): void {
    this.gridApi.showLoadingOverlay();

    this.listTenants(true);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    this.gridApi.sizeColumnsToFit();
  }

  onGridSizeChanged(params) {
    var gridWidth = document.getElementById("tenant-list").offsetWidth;
    var columnsToShow = [];
    var columnsToHide = [];
    var totalColsWidth = 0;
    var allColumns = params.columnApi.getAllColumns();
    for (var i = 0; i < allColumns.length; i++) {
      let column = allColumns[i];
      totalColsWidth += column.getMinWidth();
      if (totalColsWidth > gridWidth) {
        columnsToHide.push(column.colId);
      } else {
        columnsToShow.push(column.colId);
      }
    }
    params.columnApi.setColumnsVisible(columnsToShow, true);
    params.columnApi.setColumnsVisible(columnsToHide, false);
    params.api.sizeColumnsToFit();
  }  

  openCreateModal(){
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;

    const modalRef = this.modalService.open(CreateTenantModalComponent, this.modalOption);

    modalRef.result.then((res: boolean) => {
      if(res) {
        this.listTenants();
      }
    });
  }
  
  
  
dateComparator(date1, date2) {

  var date1Number = date1 && new Date(date1).getTime();
  var date2Number = date2 && new Date(date2).getTime();

  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

}
